import { render, staticRenderFns } from "./Communications.vue?vue&type=template&id=08901ea8&"
import script from "./Communications.vue?vue&type=script&lang=js&"
export * from "./Communications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports